import { Outlet, useLocation } from 'react-router-dom'
import andreaTheme from './theme'
import AppBar, { NavItem } from 'components/AppBar'
import Content from 'components/Content'
import { Stack, ThemeProvider } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'
import { useStore } from 'utils/store'
import { useEffect, useState } from 'react'
import AndreaPassWall from './pages/AndreaPassWall'

export default function Andrea() {
  const andreaAccess = useStore(state => state.andreaAccess)
  const andreaPassword = useStore(state => state.andreaPassword)

  useEffect(() => {
    if (!andreaAccess) {
      const localPass = window.localStorage.getItem('andreaPassword')

      if (localPass === andreaPassword)
        useStore.setState({ andreaAccess: true })
    }
  }, [andreaAccess, andreaPassword])

  return (
    <ThemeProvider theme={andreaTheme}>
      {andreaAccess ? (
        <Content bgColor='gradient' appBar={false}>
          <Outlet />
        </Content>
      ) : (
        <AndreaPassWall />
      )}
    </ThemeProvider>
  )
}
